import { createSlice } from "@reduxjs/toolkit";
import { getLanguagesThunk } from "../thunks/getLanguagesThunk";

const getLanguagesinitialState = {
  loading: false,
  error: null,
  data: [],
};

const getLanguagesSlice = createSlice({
  name: "getLanguagesSlice",
  initialState: getLanguagesinitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLanguagesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLanguagesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getLanguagesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const getLanguagesReducer = getLanguagesSlice.reducer;
